import { makeStyles } from '@material-ui/core/styles';

/**
 *
 * Material UI styles for StatusTag
 *
 *
 * @see https://material-ui.com/styles/basics
 *
 */

const useStyles = makeStyles(theme => ({
  tagText: {
    backgroundColor: props => props.backgroundColor,
    borderRadius: 3,
    color: props => props.color,
    fontSize: 12,
    padding: theme.spacing(0.5, 1),
  },
}));

export default useStyles;
